import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomRadioButton, CustomRadioButtonProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomRadioButtonWrapperProps = WithInput<CustomRadioButtonProps>;

const CustomRadioButtonWrapper: React.FC<CustomRadioButtonWrapperProps> = (props: CustomRadioButtonWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomRadioButton
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomRadioButtonWrapper);
